/*
  Search providers types
*/
import {
  AccreditedGender,
  AppointmentType,
  EstablishmentCategory
} from './establishment'

export interface EstablishmentsBaseArgs {
  categoryIds?: EstablishmentCategory[]
  siteAccreditedNetworkId?: string
  specialtyId?: string
  subSpecialtyId?: string
  /*
   * Aceito somente pela listagem. A rota `/accredited/lightweight`, que
   * alimenta os pins do mapa, nao le nenhum dos dois campos e ignora o que
   * chegar no filtro.
   */
  gender?: AccreditedGender
  appointmentType?: AppointmentType
  providerName?: string
  radiusInMeters?: string
  lat?: string
  lon?: string
  placeId?: string
  isDefaultSearch?: boolean
}

export interface EstablishmentsWithLatLonArgs extends EstablishmentsBaseArgs {
  lat: string
  lon: string
  placeId?: undefined
}

export interface EstablishmentsWithPlaceIdArgs extends EstablishmentsBaseArgs {
  placeId: string
  lat?: undefined
  lon?: undefined
}

export type EstablishmentsArgs =
  | EstablishmentsWithLatLonArgs
  | EstablishmentsWithPlaceIdArgs

export enum PositionType {
  BUILDING = 'BUILDING',
  STREET = 'STREET',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  CITY = 'CITY'
}

export type PositionTypeKeys = keyof typeof PositionType
